import React from 'react';
import { motion } from 'framer-motion';

const Button5 = ({ children, onClick, width,className="" }) => {
  return (
    <motion.button
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.03 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className={`py-2 ${className} px-6 flex items-center justify-center text-jbsBlue border-4 border-jbsBlue font-bold rounded-full text-center`}
      style={{
        
        borderRadius: '50px',
      }}
    >
      {children}
    </motion.button>
  );
};

export default Button5;
